import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { UnderlyingAsset } from "../model/interfaces/underlying-asset.interface";
import { ProductCaptureComponent } from "../product-capture.component";
import { ProductCaptureService } from "../services/product-capture.service";

@Injectable({
    providedIn: ProductCaptureComponent
})
export class CommonProductCaptureDataService {

    private _referenceRateOptions$: ReplaySubject<UnderlyingAsset[]>;

    private _eventTabChanged$ = new ReplaySubject<boolean>();

    eventTabChanged$ = this._eventTabChanged$.asObservable();

    constructor(private productCaptureService: ProductCaptureService) {
        
    }

    eventTabChanged() {
        this._eventTabChanged$.next(true);
    }

    get referenceRateOptions$() {
        if (!this._referenceRateOptions$) {
            this._referenceRateOptions$ = new ReplaySubject<UnderlyingAsset[]>(2);
            this.productCaptureService.getProductReferenceRatesOptions()
            .subscribe((referenceRateOptions: UnderlyingAsset[]) => {
                this._referenceRateOptions$.next(referenceRateOptions);
            });
        }
        return this._referenceRateOptions$.asObservable();
    }

}